import API from '../../../lib/commons/api'
import {
  ProjectRulesBatchResponse,
  ProjectRulesResponse,
  SprintTaskAssociationMode,
  SwitchabilityResponse,
} from '../../../domain/value-object/ProjectRulesVO'

export const getProjectRules = async (): Promise<ProjectRulesResponse> => {
  const response = await API.functional.request('GET', '/api/v1/projects/rules')
  return response.json as ProjectRulesResponse
}

export const updateProjectRules = async (body: {
  sprintTaskAssociationMode: SprintTaskAssociationMode
}): Promise<ProjectRulesResponse> => {
  const response = await API.functional.request(
    'PUT',
    '/api/v1/projects/rules',
    body
  )
  return response.json as ProjectRulesResponse
}

export const getProjectRulesBatch = async (
  projectUuids: string[]
): Promise<ProjectRulesBatchResponse> => {
  const response = await API.functional.request(
    'GET',
    '/api/v1/projects/rules/cross_projects',
    { projectUuids: projectUuids.join(',') }
  )
  return response.json as ProjectRulesBatchResponse
}

export const checkSwitchability = async (): Promise<SwitchabilityResponse> => {
  const response = await API.functional.request(
    'GET',
    '/api/v1/projects/rules/sprint_task_association_mode/switchability'
  )
  return response.json as SwitchabilityResponse
}
